module.exports = __webpack_public_path__ + "img/4_windAndRain_csk.9fcb49b7.png";